import styles from './adminElement.module.css'
import { useEffect, useState } from "react"
import { useConstrufyAdminActions } from "../../../../modules/construfy-admin"
import { Company, RequestStatus, useSystemActions } from "../../../../modules/system"
import { useLoad } from "./load"
import { Button, FieldValue, FileTile, FileType, O, SelectField, UploadButton, option } from "../../../ui"
import { define } from '../../../../utils/typeUtils'
import { TableName } from '../../../../tables'
import { ElementLoader } from "../element-loader/elementLoader"

export const AdminElement = () => {
  const {
    createTables,
    createUnitTypes,
    createDefaultData,
    createCompany,
    createBranch,
    createCompanyPolicies,
    saveConstrufyAdminPolicy,
    saveSystemPolicy,
    saveCompanyPolicies,
    resolveRequest,
    clearTable,
    findReferences,
    migrate,
    migrateDeliveryNotesCode,
    removeUser,
    importSuppliers,
    importProducts
  } = useConstrufyAdminActions()
  
  const [companies, setCompanies] = useState<Company[]>([])
  const [companyId, setCompanyId] = useState<string>()
  const [table, setTable] = useState<TableName>()
  const [ready, setReady] = useState(false)

  const load = useLoad()
  const systemActions = useSystemActions()

  useEffect(() => {
    load().then(() => {
      systemActions().fetchAllCompanies().then(stateCompanies => {
        setCompanies(stateCompanies)
        setReady(true)
      })
    })
  }, [])

  const [file, setFile] = useState<File>()
  
  const tables = [
    TableName.CUSTOMERS,
    TableName.LOTS,
    TableName.PRODUCTS,
    TableName.PRODUCT_PRICES,
    TableName.STOCK,
    TableName.SUPPLIERS,
  ]

  const onChangeCompany = (value?: FieldValue) => {
    setCompanyId(value as O<string>)
  }

  const onChangeTable = (value?: FieldValue) => {
    setTable(value as O<TableName>)
  }

  const onSelectFile = (newFile?: File) => setFile(newFile)
  
  const onImport = () => {
    if (file) {
      const definedCompanyId = define(companyId)
      if (table === TableName.SUPPLIERS) {
        importSuppliers(file, definedCompanyId)
      } else if (table === TableName.PRODUCTS) {
        importProducts(file, definedCompanyId)
      } 
    }
  }

  const onClear = () => {
    table && clearTable(define(companyId), table)
  }

  return (
    <ElementLoader ready={ready}>
      <>
        <button onClick={createTables}>
          Create tables
        </button>
        <button
          onClick={() => createCompany(
            'materialesmorris',
            'Materiales Morris',
            'Materiales Morris',
            20000000000,
            'info@gmail.com',
            {
              address: 'Marquez de Aviles 1999',
              locality: 'William C. Morris',
              province: 'Buenos Aires'
            }
          )}>
          Create company
        </button>
        <button onClick={() => createBranch(companyId!, '2', 'Morris', 'Andrés Arguibel 3214', 'William C. Morris', 'Buenos Aires')}>
          Create branch
        </button>
        <button onClick={createUnitTypes}>
          Create unit types
        </button>
        <button onClick={() => createDefaultData(companyId)}>
          Create default data
        </button>
        <button onClick={() => createCompanyPolicies(companyId)}>
          Create company policies
        </button>
        <button onClick={saveConstrufyAdminPolicy}>
          Save CONSTRUFY ADMIN policy
        </button>
        <button onClick={saveSystemPolicy}>
          Save SYSTEM policy
        </button>
        <button onClick={() => saveCompanyPolicies(companyId)}>
          Save company policies
        </button>
        <button onClick={() => resolveRequest('sandbox', 'tmsmateus@gmail.com', RequestStatus.APPROVED)}>
          Approve company manager
        </button>
        <button onClick={() => findReferences(companyId!, [
          "1b18ab52-eb29-41af-84f2-f7ca5af9394d",
        ])}>
          Find ID refs
        </button>
        <button onClick={migrate}>
          Migrate
        </button>
        <button onClick={migrateDeliveryNotesCode}>
          Migrate Delivery Notes Code
        </button>
        <button onClick={() => removeUser('distinctplaces@gmail.com')}>
          Remove user
        </button>
        
        <div className={styles.importContainer}>
          <SelectField
            id="companyId"
            options={companies.map(company => option(company.id, company.name))}
            onChange={onChangeCompany}
          />
          <SelectField
            id="table"
            options={tables.map(tableName => option(tableName, tableName))}
            onChange={onChangeTable}
          />
          <FileTile fileType={FileType.CSV} fileName={file?.name} />
          <UploadButton
            id='import-csv'
            fileTypes={[FileType.CSV]}
            onChange={onSelectFile}
          />
          <Button
            label="Importar"
            disabled={!companyId}
            onClick={onImport}
          />
          <Button
            label="Borrar Todo"
            disabled={!companyId}
            onClick={onClear}
          />
        </div>
      </>
    </ElementLoader>
  )
}
